import { ReactNode } from 'react';

import { usePermissions } from '../../hooks/auth/usePermissions';

interface CanProps {
  /** Requiere este permiso. */
  perm?: string;
  /** Requiere al menos uno de estos. */
  anyOf?: string[];
  /** Requiere todos estos. */
  allOf?: string[];
  /** Que renderizar si no tiene permiso (por defecto: nada). */
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Renderiza `children` solo si el usuario tiene el/los permiso(s) indicados.
 * Combina `perm` + `anyOf` + `allOf` con AND.
 *
 *   <Can perm="SALES_VOID"><Button ... /></Can>
 *   <Can anyOf={['REPORTS_VIEW','REPORTS_EXPORT']}> ... </Can>
 */
const Can = ({ perm, anyOf, allOf, fallback = null, children }: CanProps) => {
  const { can, canAny, canAll } = usePermissions();

  const ok =
    (perm ? can(perm) : true) &&
    (anyOf ? canAny(anyOf) : true) &&
    (allOf ? canAll(allOf) : true);

  return <>{ok ? children : fallback}</>;
};

export default Can;
